import ApiService from './ApiService';

export default class NotesService {
  static createNote = async ({ description, notable_type, notable_id }) =>
    ApiService.post('/notes', { description, notable_type, notable_id });

  static getAllUserNotes = async (userId) => ApiService.get(`/users/${userId}/notes`);
}
